
export default function FaceNavigation() {
  return (
    <div>
    </div>
  );

}

export { FaceNavigation };
